import type { ReactNode } from 'react';

interface FieldProps {
  label: string;
  htmlFor?: string;
  // Field-level validation error rendered below the control (per the frontend conventions).
  error?: string;
  // Optional right-aligned slot next to the label (e.g. a "Forgot?" link).
  action?: ReactNode;
  children: ReactNode;
}

// Label + control + error wrapper. Keeps every form field laid out identically.
export function Field({ label, htmlFor, error, action, children }: FieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-baseline justify-between">
        <label htmlFor={htmlFor} className="text-xs font-medium text-ink-3">
          {label}
        </label>
        {action}
      </div>
      {children}
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  );
}
